var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.ranks),function(rank){return _c('RankUsersComponent',{key:rank.name,attrs:{"title":rank.title,"api":rank.api,"name":rank.name,"list-url":rank.listUrl}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }